import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-trophy",
  "use": "icon-trophy-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-trophy\">\n<path d=\"M2.2 13.8C1.64772 13.8 1.2 13.3523 1.2 12.8V5.94296C1.2 5.00988 2.36483 4.58522 2.96536 5.29936L3.97948 6.50533C4.42657 7.03702 5.26623 6.96207 5.61209 6.3596L7.13275 3.71071C7.5171 3.0412 8.48291 3.0412 8.86725 3.71071L10.3879 6.3596C10.7338 6.96207 11.5734 7.03702 12.0205 6.50533L13.0346 5.29936C13.6352 4.58521 14.8 5.00988 14.8 5.94296V12.8C14.8 13.3523 14.3523 13.8 13.8 13.8H2.2Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/trophy.svg
// module id = zKyt
// module chunks = 258